import React from 'react';
import { useNavigate } from 'react-router-dom';
// Optional: import CSS file

const FeedbackSelectionPage = () => {
    const navigate = useNavigate();

    const handleEagleClick = () => {
        navigate('/eagle-feedback');
    };

    const handleStreaksClick = () => {
        navigate('/streaks-feedback');
    };

    return (
        <div style={{ textAlign: 'center' }}>
            <h1>Select Feedback Type</h1>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                <div style={{ border: '1px solid #ccc', padding: '20px' }}>
                    <button className="btn-search" onClick={handleEagleClick}>Eagle Feedback</button>
                </div>
                <div style={{ border: '1px solid #ccc', padding: '20px' }}>
                    <button className="btn-search" onClick={handleStreaksClick}>Streaks Feedback</button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackSelectionPage;